import ProductTagsTable from "./views/ProductTagsTable";

export default function NewProductTables() {
    return <ProductTagsTable />;
}